import React, { Children } from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

const IfFeatureLogic = {
    featureData: () => {
        throw new Error('Override IfFeature.featureData!');
    },
    isEnabled: (enabled) => {
        const features = IfFeatureLogic.featureData();
        let ok = false;
        if (enabled && features) {
            ok = (features.enabled || []).indexOf(enabled) !== -1;
        }
        return ok;
    },
    isDisabled: disabled => !IfFeatureLogic.isEnabled(disabled),
};


/**
 * Only show a feature if it is enabled.
 *
 * @prop enabled string The id of the feature to check for.
 */
export default function IfFeature(props) {
    if (props.enabled && props.disabled) {
        throw new Error('Invalid prop');
    } else if (props.enabled && IfFeatureLogic.isEnabled(props.enabled)) {
        return Children.only(props.children);
    } else if (props.disabled && IfFeatureLogic.isDisabled(props.disabled)) {
        return Children.only(props.children);
    }
    return <noscript />;
}

Object.defineProperties(
    IfFeature,
    {
        featureData: {
            get: () => IfFeatureLogic.featureData,
            set: (newValue) => {
                IfFeatureLogic.featureData = newValue;
            },
        },
        isEnabled: {
            get: () => IfFeatureLogic.isEnabled,
        },
        isDisabled: {
            get: () => IfFeatureLogic.isDisabled,
        },
    },
);

IfFeature.displayName = displayName('Containers/IfFeature');

IfFeature.propTypes = {
    disabled: PropTypes.string,
    enabled: PropTypes.string,
    children: PropTypes.node,
};

IfFeature.defaultProps = {
    disabled: '',
    enabled: '',
    children: null,
};
